// Single gate for every LOCAL-DEV ONLY code path (authShim, storageShim, the sample-file URLs).
//
// The per-feature flags (REACT_APP_LOCAL_AUTH_SHIM, REACT_APP_S3_LOCAL_ENDPOINT) are not enough on
// their own, because `npm start` ALWAYS loads `.env.development` — react-scripts 5 reads
// `.env.development.local`, `.env.local`, `.env.development`, `.env` for every dev server, and
// there is no dotenv-flow/env-cmd here to swap that out. So the documented way to point the dev
// server at a deployed environment (`export $(cat .env.stage | xargs) && npm start`) still lets any
// key that `.env.stage` does NOT define leak in from `.env.development` — and the two local-dev
// flags are exactly such keys. The result was a stage-configured app booting as the forged local
// user u-1.
//
// So the flags are additionally gated on the release stage: local-dev code runs only when
// REACT_APP_RELEASE_STAGE is 'local'. Exported vars win over dotenv files (dotenv never overwrites
// an already-set key), so sourcing any deployed env file turns the whole local layer off, whatever
// `.env.development` says.
//
// 'local' — not 'development' — because .env.stage/.env.uat/.env.dev all set RELEASE_STAGE to
// 'development' (it keeps Bugsnag and GA quiet: both allowlist prod/demo/staging only). 'local' is
// the one value no deployed env and no CircleCI job ever sets, which is what makes it a safe gate.
export const LOCAL_RELEASE_STAGE = 'local';

export const IS_LOCAL_STAGE = process.env.REACT_APP_RELEASE_STAGE === LOCAL_RELEASE_STAGE;

// The devstack MinIO endpoint, or undefined anywhere else. Import this instead of reading
// process.env.REACT_APP_S3_LOCAL_ENDPOINT directly, so the stage gate can never be bypassed.
export const LOCAL_S3_ENDPOINT = IS_LOCAL_STAGE
  ? process.env.REACT_APP_S3_LOCAL_ENDPOINT
  : undefined;
